import React, { type ReactNode } from "react";
import { Box, type BoxProps } from "@chakra-ui/react";

type MdxCodeProps = {
  children?: ReactNode;
  className?: string;
} & BoxProps;

export function MdxCode({ children, className, ...props }: MdxCodeProps) {
  const isBlock = className?.includes("language-");

  return (
    <Box
      as="code"
      className={className}
      bg="brand.backgroundSecondary.light"
      color="new.gray.900"
      borderRadius="tinier"
      fontFamily="mono"
      whiteSpace="pre-wrap"
      px={isBlock ? 0 : 1}
      py={isBlock ? 0 : 0.5}
      sx={{
        span: { overflowWrap: "anywhere" },
        ":not(.mdx-heading &)": {
          fontSize: "sm",
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
}
